import React from "react";
import { CheckCircle2, X } from "lucide-react";

export default function SuccessToast({ open, title, message, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed right-6 top-6 z-[60] flex w-[360px] items-start gap-3 rounded-xl border border-gray-100 bg-white p-4 shadow-lg">
      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-blue-500" />
      <div className="flex-1 text-left">
        <p className="text-sm font-semibold text-[#1D2739]">{title}</p>
        <p className="mt-0.5 text-sm text-gray-500">{message}</p>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="rounded p-0.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
